export default function ThreeReasons() {
  const reasons = [
    {
      icon: 'ri-shield-check-line',
      number: '01',
      title: '行政書士による\n"法務一体型"補助金サポート',
      description: '補助金申請だけでなく、契約書・内容証明・許認可など企業の法務相談もワンストップで対応できます。補助金と法務を同時に扱える専門家は稀少で、企業にとって大きなメリットになります。',
      color: 'from-blue-900 to-blue-700',
      iconBg: 'bg-blue-900'
    },
    {
      icon: 'ri-price-tag-3-line',
      number: '02',
      title: '成功報酬が\n業界最安級（3〜10%）',
      description: '一般の補助金代行は成功報酬15〜20%が相場ですが、TOKANでは顧問先に限り成功報酬が3〜10%という特別料金で対応しています。継続して補助金を活用する企業にとって、費用負担が大幅に軽減されます。',
      color: 'from-orange-500 to-orange-600',
      iconBg: 'bg-orange-500'
    },
    {
      icon: 'ri-line-chart-line',
      number: '03',
      title: '補助金とLP制作をつなぐ\n"売上アップ型"サポート',
      description: '補助金を使って購入・導入した設備やサービスを、そのままLPで"魅力として見える化"できます。補助金を取るだけの支援ではなく、売上増加にも直結する導線を設計できるのがTOKANの最大の強みです。',
      color: 'from-yellow-500 to-yellow-600',
      iconBg: 'bg-yellow-500'
    }
  ];

  return (
    <section id="reasons" className="py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            TOKANが選ばれる<span className="text-blue-900">3つの理由</span>
          </h3>
          <p className="text-lg text-gray-600">一気通貫だからこそ実現できる、圧倒的な価値提供</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-6">
                <div className={`w-16 h-16 ${reason.iconBg} rounded-2xl flex items-center justify-center`}>
                  <i className={`${reason.icon} text-white text-3xl`}></i>
                </div>
                <div className={`text-6xl font-bold bg-gradient-to-br ${reason.color} bg-clip-text text-transparent opacity-20`}>
                  {reason.number}
                </div>
              </div>

              <h4 className="text-xl font-bold text-gray-900 mb-4 leading-relaxed whitespace-pre-line" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                {reason.title}
              </h4>

              <p className="text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
